import React from "react";
import {
  aboutDetails,
  aboutTitle,
  MarCouponCode,
  NoticeBySpotahome,
} from "../../settings/About/AboutUtils";

const About = () => {
  return (
    <div className="landing">
      <div className="dark-overlay landing-inner text-light">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h1 className="display-3 mb-4">{aboutTitle}</h1>
              <p className="lead ">{aboutDetails}</p>
            </div>
            <div className="container row d-flex ">
              <div
                className="col-md-6 col-sm-12 text-center bg-white text-dark border border-2 d-none d-lg-block d-md-block b-info rounded"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minheight: "300px",
                  width: "200px",
                }}
              >
                <NoticeBySpotahome />
              </div>
              <MarCouponCode />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
